export default __webpack_public_path__ + "pgnv-assets/01544aaa15beb3337fae2d0ef7ee405e.png";